import React from "react";
import _ from "lodash";
import { getData } from "Source/globalFunction";

class Name extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const handleChange = (e) => {
            this.props.onChange(e);
            handleNameExists(e.target.value);
        }

        const handleNameExists = _.debounce((value) => {
            const url = "api/calendar/checkCalendarName";
            const params = { name: value };

            getData(url, { params }, response => {
                if (response) {
                    if (value) {
                        this.props.onNameExists(response.status === 400 ? true : false);
                    } else {
                        this.props.onNameExists(null);
                    }
                }
            })
        }, 300);

        return (
            <div class="formControl">
                <input class={this.props.isNameExists ? "has-error" : ""} type="text" placeholder="Type here" value={this.props.value} onChange={handleChange} />
                {this.props.isNameExists && <span class="errorMessage">Calendar name already exists</span>}
            </div>
        );
    }
}

export default Name;